import React, { useMemo } from 'react';
import PieChart, { Slice } from '@tcs/common/components/atoms/PieChart';
import InfoCard from '@tcs/common/components/molecules/InfoCard';
import { sum } from 'lodash';
import { Account } from '@tcs/client-portal-api/types/Account';
import { palette } from '@forgeglobal/design-framework';

export interface AccountsDistributionCardProps {
  accounts: Account[];
}

const MAX_DISPLAY_ITEMS = 6;

export const AccountsDistributionCard = ({
  accounts,
}: AccountsDistributionCardProps) => {
  const slices = useMemo(() => {
    const assetColors = Object.values(palette.dataVisualizationColors);

    const totalValue = accounts.reduce<number>(
      (aggregateTotal: number, { totalValue }: Account) =>
        aggregateTotal + totalValue,
      0
    );

    const allSlices: Slice[] = [
      ...accounts.map((account, index) => ({
        value: (account.totalValue / totalValue) % 100,
        label: account.displayAccountType,
        color: assetColors[index % assetColors.length],
      })),
    ];

    allSlices.sort((a, b) => b.value - a.value);

    if (allSlices.length <= MAX_DISPLAY_ITEMS) {
      return allSlices;
    } else {
      return [
        ...allSlices.slice(0, MAX_DISPLAY_ITEMS - 1),
        {
          label: 'OTHER',
          value: sum(
            allSlices
              .slice(MAX_DISPLAY_ITEMS - 1, allSlices.length)
              .map((s) => s.value)
          ),
          color: assetColors[MAX_DISPLAY_ITEMS - 1],
        },
      ];
    }
  }, [accounts]);

  return (
    <InfoCard title={'Accounts Distribution'}>
      <PieChart slices={slices} />
    </InfoCard>
  );
};

export default AccountsDistributionCard;
